var App = App || {};

App.ComparisonTable = (function ($) {
    'use strict';

    var Bps = ["xs", "sm", "md"],
        Bpm = ["md"],
        Bp = ZAGFramework.GetCurrentBP(),
        ColumnsAllowed = 2;

    function init() {

        if (Bps.includes(Bp)) { CompareSetup() }
        $(document).bind("enter-xs enter-sm enter-md", function () { CompareSetup() });
        $(document).bind("enter-lg enter-xl enter-xxl", function () { CompareMobileKill() });
        // if we have any products to compare, then attach a scroll handler to the window scroll event
        if ($(".comparison-table").length > 0) {
            $(window).on('scroll', onTableScroll);
        }

    }

    function CompareSetup() {
        Bp = ZAGFramework.GetCurrentBP();

        $(".comparison-table").each(function () {

            var Component = $(this),
                Controls = Component.find(".comparison-table-controls").find(".form-check-input");

            ColumnsAllowed = $(Controls).length;
            if (Bps.includes(Bp)) {
                if (Bpm.includes(Bp)) { //allow up to 5 column comparison on tablet
                    if ($(Controls).length >= 5) {
                        ColumnsAllowed = 5;
                    }
                }
                else if ($(Controls).length >= 2) { //allow up to 2 column comparison on mobile
                    ColumnsAllowed = 2;
                }
            }

            //check & enable only allowed number of boxes
            Controls.prop("checked", false).attr("disabled", "disabled");
            for (var i = 0; i < ColumnsAllowed; i++) {
                $(Controls[i]).prop("checked", true).removeAttr("disabled");
            }

            CompareUpdate(Component);
            Controls.on("change", function () { CompareUpdate(Component); });

        });
    }

    function CompareUpdate(Component) {
        var Controls = Component.find(".comparison-table-controls"),
            ChartContent = Component.find(".table-responsive"),
            ControlsChecked = [];

        Controls.find(".form-check-input").each(function () {
            if ($(this).prop("checked")) {
                ControlsChecked.push($(this).attr("id"));
            }
        });

        //if allowed number of options are selected, disable the rest
        if (ControlsChecked.length >= ColumnsAllowed) {
            Controls.find(".form-check-input").each(function () {
                if (!$(this).prop("checked")) {
                    $(this).attr("disabled", "disabled");
                }
            });
        }
        else { //otherwise enable all
            Controls.find(".form-check-input").each(function () {
                $(this).removeAttr("disabled");
            });
        }

        if (!ControlsChecked.length) { ChartContent.hide(); }
        else { ChartContent.show(); }

        Component.find(".target-column").each(function () {
            var Control = $(this).attr("aria-controlledby");
            if (ControlsChecked.includes(Control)) {
                //show all selected columns
                $(this).show();
                //add left border unless this is the first visible column
                if (!ControlsChecked[0].includes(Control)) {
                    $(this).addClass("second-column");
                }
                else {
                    $(this).removeClass("second-column");
                }
            }
            else {
                $(this).hide();
            }
        });

        Component.find(".target-header").attr("colspan", ControlsChecked.length);
    }

    function CompareMobileKill() {
        //set comparison chart to desktop configuration
        $(".comparison-table").each(function () {

            var Component = $(this),
                Controls = Component.find(".comparison-table-controls").find(".form-check-input"),
                ChartContent = Component.find(".table-responsive"),
                TargetColumns = Component.find(".table-responsive").find(".target-column"),
                TargetHeaders = Component.find(".table-responsive").find(".target-header");

            Controls.prop("checked", false).removeAttr("disabled");
            ChartContent.show();
            TargetColumns.show();
            TargetHeaders.attr("colspan", Controls.length);

        });
    }

    function onTableScroll() {
        $(".comparison-table").each(function () {
            var navBottom = $(window).scrollTop(),
                navOffset = 0,
                tableTop = $(this).find(".table-responsive").first().offset().top;

            if ($("section.headernav").first().length) {
                navOffset = $("section.headernav").outerHeight();
                navBottom = $("section.headernav").first().offset().top + navOffset;
            }

            if (navBottom > tableTop) {
                $(this).find("thead").addClass("scrolling").css("top", navOffset + "px");
            } else {
                $(this).find("thead").removeClass("scrolling");
            }
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.ComparisonTable.init();
});